import { AxiosError } from 'axios'
import { useParams } from 'react-router-dom'

import useGetCampaignById from '~/features/campaigns/hooks/useGetCampaignById'
import {
  ECampaignExecutionMode,
  ECampaignExecutionStatus,
  ECampaignKeys,
  ECampaignStatus,
  ECampaignType,
  EMessageStrategy,
} from '~/features/campaigns/models'
import { isSharedCampaign } from '~/features/campaigns/utils/campaignJunctions'

export default function useGetSelectedCampaign() {
  const { id: campaignId } = useParams()
  const {
    data: { data: campaign } = {},
    isLoading,
    isError,
    error,
  } = useGetCampaignById(campaignId || '', {
    retry: false,
    retryOnMount: false,
  })

  const status = campaign?.[ECampaignKeys.executionStatus]
  const type = campaign?.[ECampaignKeys.campaignType]
  const isManual = campaign?.[ECampaignKeys.ofuIsManual]
  const isOneTime =
    campaign?.[ECampaignKeys.campaignType] === ECampaignType.ofuOneTime
  const isFollowUp =
    campaign?.[ECampaignKeys.campaignType] === ECampaignType.ofu
  const isSimple =
    campaign?.[ECampaignKeys.campaignType] === ECampaignType.simple
  const isDraft =
    campaign?.[ECampaignKeys.executionStatus] ===
    ECampaignExecutionStatus.notStarted
  const isPaused =
    campaign?.[ECampaignKeys.executionStatus] ===
    ECampaignExecutionStatus.paused
  const isActive =
    campaign?.[ECampaignKeys.executionStatus] ===
    ECampaignExecutionStatus.inProgress

  const isArchived =
    campaign?.[ECampaignKeys.status] === ECampaignStatus.archived
  const isManualExecution =
    campaign?.[ECampaignKeys.executionMode] === ECampaignExecutionMode.manual
  const isAiMessageStrategy =
    campaign?.[ECampaignKeys.messageStrategy] === EMessageStrategy.aiGenerated

  const isTest = campaign?.[ECampaignKeys.status] === ECampaignStatus.test
  const isNotFound = isError && (error as AxiosError)?.response?.status === 404
  const isShared = isSharedCampaign(campaign)

  return {
    campaign,
    isLoading,
    isError,
    error,
    isNotFound,
    status,
    type,
    isArchived,
    isManual,
    isOneTime,
    isFollowUp,
    isSimple,
    isDraft,
    isPaused,
    isActive,
    isManualExecution,
    isAiMessageStrategy,
    isTest,
    isSharedCampaign: isShared,
  }
}
